// import { Grid } from "@mui/material";

// interface PlanInfoRowProps {
// 	label: string;
// 	children: React.ReactNode;
// }

// const PlanInfoRow = ({ label, children }: PlanInfoRowProps) => {
// 	return (
// 		<Grid container spacing={1} alignItems="center" className="pf-label">
// 			<Grid item xs={12} md={3}>
// 				<div className="pf-label-text">{label}</div>
// 			</Grid>
// 			<Grid item xs={12} md={9}>
// 				<div className="field-value">{children}</div>
// 			</Grid>
// 		</Grid>
// 	);
// };

// export default PlanInfoRow;

import { Grid, Typography, Box } from "@mui/material";
import { ReactNode } from "react";

interface PlanInfoRowProps {
	label: string;
	children: ReactNode;
}

const PlanInfoRow = ({ label, children }: PlanInfoRowProps) => {
	return (
		<Box
			sx={{
				p: 1,
				backgroundColor: "#fff",
				display: "flex",
				alignItems: "center",
				minHeight: "44px"
				// borderBottom: "1px solid #f0f0f0"
			}}
		>
			<Grid container spacing={1} alignItems="flex-start" className="pf-label">
				<Grid item xs={12} md={3}>
					<Typography variant="body1" fontWeight={800} fontSize="0.95rem" color="text.primary">
						{label}
					</Typography>
				</Grid>

				<Grid item xs={12} md={9}>
					<Box>
						{children ?? (
							<Typography variant="body2" color="text.secondary">
								N/A
							</Typography>
						)}
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export default PlanInfoRow;
